
import { defineComponent, PropType } from 'vue'

// components
import Cheap from '@/common/components/UI/Cheap/index.vue'

// types
import { VacanciesVacancyT } from '@/core/types/vacancies.types'

// enums
import { VacancyStatusesT } from '@/core/enums/vacancies.enums'

export default defineComponent({
    components: {
        cheap: Cheap,
    },
    props: {
        item: {
            type: Object as PropType<VacanciesVacancyT>,
            default: null,
        },
    },
    setup() {
        return { VacancyStatusesT }
    },
})
